import { Typography as MuiTypography } from "@mui/material";
import { ParsedValue } from "../TextWithValue";
import { cn } from "@/src/shared/utils/mergeTwClasses";

export function Text(props: any) {
  const { type, text, displayName, lineHeight, className, ...rest } = props;
  return (
    <MuiTypography
      gutterBottom
      className={cn("w-full gradient-text", className)}
      style={{
        ...rest,
        justifyContent: rest.textAlign,
        background: rest.background || "#000",
        lineHeight: lineHeight ? lineHeight + "px" : "",
      }}
    >
      {props.children || <ParsedValue value={props.text} />}
    </MuiTypography>
  );
}
